<template>
  <div v-if="data" class="p-0" :class="{'card': !panelLayout}">
    <div class="card-header d-flex" v-if="!panelLayout">
      <router-link :to="detailRoute">
        <span class="font-weight-bold">
          <font-awesome-icon :icon="icon" fixed-width class="mr-2"/>
          {{ typeName }}:&nbsp;
        </span>
        <slot name="header"></slot>
      </router-link>
    </div>
    <div class="card-body p-1 p-md-3" :class="{'card-body': !panelLayout}">
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
import {getIcon, getTypeName} from "@/utils/business-objects";

export default {
  name: 'DetailCard',
  props: {
    data: Object,
    type: String
  },
  computed: {
    id() {
      return this.data.id || this.data.number
    },
    detailRoute() {
      return {name: this.type + 'Detail', params: {id: this.id}}
    },
    icon() {
      return getIcon(this.type)
    },
    panelLayout() {
      return this.$attrs['panel-layout']
    },
    typeName() {
      return getTypeName(this.type)
    }
  }
}
</script>
